import React from 'react';
import Gallery from '../../components/Gallery.js';
import TextBlockOben from '../../components/TextBlockOben.js';

const images = [
  {
    src: require('../../images/WollKi_ohneSpitze2.png'),
    title: '',
    caption: ''
  },
  {
    src: require('../../images/WollKi_ohneSpitze1.png'),
    title: '',
    caption: ''
  },
  {
    src: require('../../images/WollKi_mitSpitze4kurz.png'),
    title: '',
    caption: ''
  },
   {
    src: require('../../images/WollKi_mitSpitze2.png'),
    title: '',
    caption: ''
  },
  {
    src: require('../../images/WollKi_mitSpitze1.png'),
    title: '',
    caption: ''
  },
  {
    src: require('../../images/WollKi_mitSpitze3.png'),
    title: '',
    caption: ''
  },
];


const Sitzkissen = (props) => {
  console.log(images);
  return (
    <TextBlockOben>
            <h1>Sitzkissen</h1>
            <p>Mein "WollKi - Das Wohlfühlkissen" stelle ich aus Wolle einheimischer Landschaftsschafe in verschiedenen Größen her.</p>
            <p>Die Farbvarianten bestehen aus den natürlichen Farben der Schafrassen.<br/></p>
        <Gallery images={images} />
    </TextBlockOben>
  );
}


export { Sitzkissen };
